import { COMPOSITION_SAVE, COMPOSITION_SAVE_FAILURE, GET_TEMPLATEID_DETAILS, 
    GET_TEMPLATEID_DETAILS_FAILURE,GET_COMPOSITIONID_DETAILS,GET_COMPOSITIONID_DETAILS_FAILURE, GET_ICD10_DETAILS,GET_ICD10_DETAILS_FAILURE} from "../../shared/constants";
import {ehrServices} from "../services";

export function saveComposition(data,patientId,visitId,templateId,patientEhrid,notesDetails,procedure,resCb) {
    console.log("SearchText,Action",data);
    return (dispatch) => {
        console.log("SearchText,Action",data)
        ehrServices.saveComposition(data,patientId,visitId,templateId,patientEhrid,notesDetails,procedure)
            .then(
                user => { 
                    console.log("Res",user)
                    dispatch(success(COMPOSITION_SAVE, user));
                    resCb(user);
                },
                error => {
                    dispatch(failure(COMPOSITION_SAVE_FAILURE, error.toString()));
                   resCb(error.toString);
                }
            );
    };
}

export function getTemplateById(data,templateId,patientInfo,resCb) {
    return (dispatch) => {
        const encodeTemplateId = encodeURIComponent(templateId);
        ehrServices.getTemplateById(encodeTemplateId,patientInfo,data)
            .then(
                user => { 
                    console.log("Res",user)
                    dispatch(success(GET_TEMPLATEID_DETAILS, user));
                    resCb(user);
                },
                error => {
                    dispatch(failure(GET_TEMPLATEID_DETAILS_FAILURE, error.toString()));
                    resCb(error.toString);
                }
            );
    };
}

// added on 26-03-2025 for suggestionapi
export function getSuggestionById(patientid,visitid,resCb) {
    return (dispatch) => {
        ehrServices.getSuggestionById(patientid,visitid)
            .then(
                user => { 
                    console.log("Res",user)
                    dispatch(success(GET_TEMPLATEID_DETAILS_FAILURE, user));
                    resCb(user);
                },
                error => {
                    dispatch(failure(GET_TEMPLATEID_DETAILS_FAILURE, error.toString()));
                }
            );
    };
}

export function getIcd10Values(data,resCb) {
    return (dispatch) => {
        ehrServices.getIcd10Values()
            .then(
                user => { 
                    console.log("Res",user)
                    dispatch(success(GET_ICD10_DETAILS, user));
                    resCb(user);
                },
                error => {
                    dispatch(failure(GET_ICD10_DETAILS_FAILURE, error.toString()));
                    resCb(error.toString);
                }
            );
    };
}

export function getCompositionByVid(data,versionUid,patientEhrid,resCb) {
    return (dispatch) => {
        ehrServices.getCompositionByVid(versionUid,patientEhrid)
            .then(
                user => { 
                    console.log("Res",user)
                    dispatch(success(GET_COMPOSITIONID_DETAILS, user));
                    resCb(user);
                },
                error => {
                    dispatch(failure(GET_COMPOSITIONID_DETAILS_FAILURE, error.toString()));
                    resCb(error.toString);
                }
            );
    };
}

function success(type, data){
    return { type: type, payload : data }
}
function failure(type, value) {
    return { type: type, payload : value };
}

export function syncPrescriptionToErp(prescription, resCb) {
    return () => {
        return ehrServices.syncPrescriptionToErp(prescription).then(
            response => {
                if (resCb) resCb(response);
                return response;
            },
            error => {
                if (resCb) resCb({
                    warningMessages: ["Prescription was saved in HMS, but could not be pushed to ERP"],
                    error: error.toString()
                });
                return null;
            }
        );
    };
}

export function deletePrescriptionFromErp(prescription, resCb) {
    return () => {
        return ehrServices.deletePrescriptionFromErp(prescription).then(
            response => {
                if (resCb) resCb(response);
                return response;
            },
            error => {
                if (resCb) resCb({
                    warningMessages: ["Prescription was deleted in HMS, but could not be deleted in ERP"],
                    error: error.toString()
                });
                return null;
            }
        );
    };
}

const ehrActions = {
    saveComposition,
    syncPrescriptionToErp,
    deletePrescriptionFromErp,
    getTemplateById,
    getCompositionByVid,
    getIcd10Values,
    getSuggestionById
}

export default ehrActions;
